<app-titulo-paginas titulo="Meus Relatórios"></app-titulo-paginas>
<mat-card class="example-card">
  <mat-card-content>
    <div class="row" style="margin-bottom: 15px;">
        <button style="margin: 12px; border-radius: 19px;" class="btn btn-primary btn-madelife" (click)="createReport()">
          <i class="fas fa-plus"></i>
          Novo Relatório
        </button>
    </div>
    <div *ngIf="loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <table class="table table-hover">
      <thead>
        <tr>
          <th> Paciente </th>
          <th> Mês </th>
          <th> Ano </th>
          <th> Ações </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let relatorio of relatorios; let i = index">
          <td>{{ relatorio?.paciente?.pessoa?.nome }}</td>
          <td data-title="Mes">{{ reportUtil.formatMounth(relatorio?.mes) }}</td>
          <td data-title="Ano">{{ relatorio?.ano }}</td>
          <td data-title="Ações" class="acao-btn-tabela" style="vertical-align: middle;">
            <a href="javascript:void(0)" [matMenuTriggerFor]="menu" matTooltip="Ações">
              <mat-icon aria-hidden="true" style="color: #4fd994;" aria-label="Example home icon">menu
              </mat-icon>
            </a>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog(relatorio)">
                <mat-icon aria-hidden="true" style="color: #337ab7;">
                  visibility
                </mat-icon>
                <span>Visualizar</span>
              </button>
              <button
              mat-menu-item
              [routerLink]="['/main/supplier-reports/edit', relatorio.id]"
            >
              <mat-icon style="color: #f0ad4e">edit </mat-icon>
              <span>Editar</span>
            </button>
            </mat-menu>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card-content>
</mat-card>
